module.exports = __webpack_public_path__ + "img/claudio.ff649cc6.jpg";